import API from "./API";
import currentUserStore from "../stores/data/currentUserStore";

function fetchCurrentUser() {
	API.get("current_user").then(currentUserStore.updateCurrentUser);
}

export default fetchCurrentUser;
